import { type AvatarId, avatarEmoji } from '@cube-rush/shared';
import './Avatar.css';

export interface AvatarProps {
  avatar: AvatarId;
  size?: 'small' | 'normal' | 'big';
  /** Glowing ring while the player talks in the voice chat. */
  speaking?: boolean;
  /** Greyed out (player disconnected). */
  dimmed?: boolean;
  /** Ring colour, usually the player's primary cube colour. */
  ring?: string;
}

export function Avatar({
  avatar,
  size = 'normal',
  speaking = false,
  dimmed = false,
  ring,
}: AvatarProps) {
  const classes = [
    'avatar',
    `avatar--${size}`,
    speaking && 'avatar--speaking',
    dimmed && 'avatar--dimmed',
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <span class={classes} style={ring ? { '--ring': ring } : undefined} aria-hidden="true">
      {avatarEmoji(avatar)}
    </span>
  );
}
